import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchSendinblueFolders() {
    try {
        const result = yield call(AxiosCall, '/sendinblue/get_all_folders/');
        yield put(actions.fetchSendinblueFoldersSuccess(result.data.results));
    } catch (e) {
        yield put(actions.fetchSendinblueFoldersFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers folders
        takeLatest(actions.FETCH_SENDINBLUE_FOLDERS_REQUEST, fetchSendinblueFolders),
    ])
}